"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { type ReactNode } from "react";

// Initialize PostHog at module load time (no useEffect needed).
// A useEffect here would run after PostHogPageView's effect (child effects fire
// before parent effects), causing the initial $pageview capture to be dropped
// silently by posthog-js since the client isn't __loaded yet.
const key = import.meta.env.VITE_POSTHOG_KEY;
const host = import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com";

if (key && typeof window !== "undefined") {
    posthog.init(key, {
        api_host: host,
        capture_pageview: false, // 수동으로 제어 (TanStack Router 연동)
        capture_pageleave: true,
        person_profiles: "identified_only",
    });
}

type Props = {
    children: ReactNode;
};

export const PostHogProvider = ({ children }: Props) => {
    return <PHProvider client={posthog}>{children}</PHProvider>;
};
